module.exports = __webpack_public_path__ + "968b1a59fef174e44fcaa906ec7f04d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_38.jpg
// module id = 1744
// module chunks = 5